<template>
    <div>
        <h5>{{ name }}</h5>
        <button v-for="option in options" type="button" class="btn btn-secondary btn-lg options"
                @click="selectOption(option.value)"
                v-bind:class="{ active: selected == option.value }">{{ option.value }}
        </button>
    </div>
</template>

<script>
    export default {
        props: ['name', 'options'],
        data() {
            return {
                selected: null,
            }
        },
        methods: {
            selectOption(option) {
                this.selected = option;
                this.$emit('select-multiple', this.name, this.selected);
            }
        }
    }
</script>